import React, { useState } from "react";
import * as XLSX from "xlsx";

const Decryptor = () => {
  const [decodeFile, setDecodeFile] = useState(null);
  const [decryptFile, setDecryptFile] = useState(null);

  // Handle file upload
  const handleFileUpload = (e, setter) => {
    const file = e.target.files[0];
    setter(file);
  };

  // Parse Excel file to JSON
  const parseExcel = async (file) => {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    return XLSX.utils.sheet_to_json(sheet);
  };

  // Generate Excel from JSON and download it
  const generateExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, fileName);
  };

  // Decrypt to code
  const decryptToCode = async () => {
    if (!decodeFile || !decryptFile) {
      alert("אנא העלה את שני הקבצים הנדרשים");
      return;
    }

    const decodeData = await parseExcel(decodeFile);
    const decryptData = await parseExcel(decryptFile);

    const decryptMap = new Map(
      decryptData.map((row) => [row["שם תאגיד"], row["קוד תאגיד"]])
    );

    const updatedData = decodeData.map((row) => {
      if (decryptMap.has(row["שם תאגיד"])) {
        row["קוד תאגיד"] = decryptMap.get(row["שם תאגיד"]);
      }
      return row;
    });

    generateExcel(updatedData, "Decoded_to_Code.xlsx");
  };

  // Decrypt to name
  const decryptToName = async () => {
    if (!decodeFile || !decryptFile) {
      alert("אנא העלה את שני הקבצים הנדרשים");
      return;
    }

    const decodeData = await parseExcel(decodeFile);
    const decryptData = await parseExcel(decryptFile);

    const decryptMap = new Map(
      decryptData.map((row) => [row["קוד תאגיד"], row["שם תאגיד"]])
    );

    const updatedData = decodeData.map((row) => {
      if (decryptMap.has(row["קוד תאגיד"])) {
        row["שם תאגיד"] = decryptMap.get(row["קוד תאגיד"]);
      }
      return row;
    });

    generateExcel(updatedData, "Decoded_to_Name.xlsx");
  };

  return (
    <div style={{ padding: "20px", direction: "rtl" }}>
      <h2>פענוח קבצים</h2>
      <div>
        <label>
          <strong>קובץ לפענוח:</strong>
        </label>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={(e) => handleFileUpload(e, setDecodeFile)}
        />
      </div>
      <div>
        <label>
          <strong>קובץ מפענח:</strong>
        </label>
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={(e) => handleFileUpload(e, setDecryptFile)}
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <button onClick={decryptToCode} style={{ marginRight: "10px" }}>
          פענוח לקוד
        </button>
        <button onClick={decryptToName}>פענוח לשם</button>
      </div>
    </div>
  );
};

export default Decryptor;
